module.exports = __webpack_public_path__ + "img/shiftytargets.a4bf065c.png";